<template>
  <o-sales-view
    nav-bar-title="MIVB"
    title="JUMP 10 journeys"
    image="images/mivb-header.jpg"
    :points="35"
    price="14,00"
    :tabs="tabs"
  >
    <o-section>
      <o-select-input icon="mobib" initial="optie1">
        <option value="optie1" selected>
          My red MOBIB card - 1234567890123456789
        </option>
        <option value="optie2">Green card - 1234567890123456789</option>
        <option value="optie3">
          My friend's MOBIB card - 1234567890123456789
        </option>
      </o-select-input>
    </o-section>
    <o-section>
      <o-alert>
        1. Orders made before 4 o’clock in the afternoon on weekdays = available
        for uploading next day.<br />
        2. Please do not forget to load your JUMP 10 on your MOBIB card. More
        info by clicking the info button above.
      </o-alert>
    </o-section>
  </o-sales-view>
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'MIVB',
  components: {
    OSalesView
  },
  data() {
    return {
      tabs: [
        {
          label: '10 journeys',
          isSelected: true
        },
        {
          label: '5 journeys'
        }
      ]
    }
  }
}
</script>
